import { replace } from 'svelte-spa-router'

import Frame from './Frame.svelte';
import Mobile from './Mobile.svelte';
import StartProfile from '../config/StartProfile.svelte';
import ProfileManager from '../config/ProfileManager.svelte';
import Download from '../config/Download.svelte';
import LocalSerial from '../LocalSerial.svelte';
import Debug from '../debug/Debug.svelte';
import WebRTCToggle from '../webrtc/Toggle.svelte';
import Wheel from '../misc/Wheel.svelte';
import Test from '../misc/Test.svelte';
import Reset from '../misc/Reset.svelte';
import Frequency from '../cat/Frequency.svelte';
import Settings from '../settings/Settings.svelte';
import Auxiliary from '../aux/Auxiliary.svelte';
import FT8 from '../ft8/FT8.svelte';
import RigControl from './RigControl.svelte';
import Row from './Row.svelte';
import Col from './Col.svelte';
import Col2 from './Col2.svelte';

export const routes = {
  '/': StartProfile
, '/startprofile': StartProfile
, '/rig/*': Frame
, '/sim/mobile/*': Mobile
, '/download': Download
, '/download/*': Download
, '/profiles': ProfileManager
, '/debug': Debug
, '/debug/wheel': Wheel
, '/serial': LocalSerial
, '/test': Test
, '/Reset': Reset
, '*': Debug
}

export const subroutes = {
  '/rigcontrol': RigControl
, '/debug': Debug
, '/webrtc': WebRTCToggle
, '/ft8': FT8
, '/aux': Auxiliary
, '/frequency': Frequency
, '/settings': Settings
, '/test': Test
, '/r': Row
, '/c': Col
, '/c2': Col2
, '/profilemanager' : ProfileManager
, '/Reset': Reset
, '*': Debug
}

export function gotoRoot() { replace('/') }
export function gotoProfiles() { replace('/profiles') }
export function gotoRigcontrol() { replace('/rig/rigcontrol') }
export function gotoDownload() { replace('/download') }